import { Component, ViewEncapsulation, HostBinding } from '@angular/core';
import { Location } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NotFoundComponent {
  @HostBinding('style.height') height = '100vh';
  @HostBinding('style.overflow') overflow = 'hidden';

  constructor(private location: Location) {}

  voltar() {
    this.location.back();
  }
}
